module.exports = "/_next/static/images/b6f6d26baa9dc0c790fcd399ca9dda9f-rec-group-white.svg.webp";